import { render, staticRenderFns } from "./FrontMenu.vue?vue&type=template&id=0cfff5a0&"
import script from "./FrontMenu.vue?vue&type=script&lang=js&"
export * from "./FrontMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports